import React, {Component} from 'react';
import {api} from "../rest";
import swal from "sweetalert2";
import Loading from "./loading";
import moment from "moment";
import linkState from "../state";
import "./form_service_route.css";
import update from "react-addons-update";
import {mapStateToData} from "../transformer";

export default class FormServiceRoute extends Component {
	constructor() {
		super();
		this.initialState = {
			"data:move.0.salida": "",
			"data:move.0.regreso": "",
			"data:move.1.salida": "",
			"data:move.1.regreso": "",
			modelo: "",
			autobus: "",
			destino: "",
			folio: "",
			contratante: "",
			selection: [
				false,
				false,
				false,
				false,
				false,
				false,
				false
			],
			semana: moment().format("YYYY-MM-DD"),
			fetching: false
		}
		this.state = this.initialState;
		this.linkState = linkState.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	handleFormSubmit(e) {
		e.preventDefault();
		const {destino, folio, contratante, selection, semana, autobus} = this.state;
		let dataState = mapStateToData(this.state).move;
		const data = {
			semana,
			moves: Object.keys(dataState).map(key=>{
				return {
					salida: `1970-01-01 ${dataState[key].salida}`,
					regreso: `1970-01-01 ${dataState[key].regreso}`
				};
			}),
			destino,
			folio,
			"contractor_id": contratante,
			selection
		};
		this.setState({fetching: true});
		api.post(`buses/${autobus}/services/route`, data)
		.then(()=> {
			swal("Servicios creados","", "success");
			this.setState(this.initialState);
		})
		.catch(error=> {
			if (error.response) {
				if (error.response.status === 406) {
					//http://stackoverflow.com/questions/24816/escaping-html-strings-with-jquery
					const info = error.response.data.map(({salida, regreso, destino})=> {
						const scapedDestino = destino.replace(/[\"&<>]/g, function (a) {
							return {'"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;'}[a];
						});
						return `<li>${scapedDestino}:<br/>${salida} &rarr; ${regreso}</li>`
					}).reduce((info)=>info);
					swal("Conflictos", `<ul>${info}</ul>`, "info");
				} else {
					swal("Error", `Status: ${status}`, "error");
				}
			} else {
				swal("Error", error.message, "error");
			}
			console.error()
		})
		.then(()=> {
			this.setState({fetching: false});
		})
	}

	handleSelectionUpdate (index) {
		this.setState({
			selection: update(this.state.selection, {[index]: {$set: !this.state.selection[index]}})
		});
	}

	render() {
		const contratantes = this.props.contratantes.map(({name, id}, i)=><option key={i} value={id}>{name}</option>);
		const {data} = this.props;
		const models = data.map(({name, id}, i)=><option key={i} value={id}>{name}</option>);
		let buses;
		try {
			buses = data.find(({id})=>id == this.state.modelo).buses.map(({id, name}, i)=><option key={i}
																								  value={id}>{name}</option>);
		} catch (e) {
			//found nothing
		}
		return (
			<form className="group columns small-12" onSubmit={this.handleFormSubmit}>
				<Loading loading={this.state.fetching}/>
				<div className="group-title">Crear nuevo servicio</div>
				<div className="row">
					<div className="columns small-12">
						<div className="row">
							<label className="columns small-3">
								<em>Seleccionar semana</em>
								<input type="date" {...this.linkState("semana")}
									   required/>
							</label>
						</div>
					</div>
					<label className="columns small-3">
						<em>Salida #1</em>
						<input type="time" {...this.linkState("data:move.0.salida")}
							   required/>
					</label>
					<label className="columns small-3">
						<em>Regreso #1</em>
						<input type="time" {...this.linkState("data:move.0.regreso")}
							   min={moment(this.state["data:move.0.salida"], "HH:mm:ss").add(1, "minute").format("HH:mm:ss")}
							   required/>
					</label>
					<label className="columns small-3">
						<em>Salida #2</em>
						<input type="time" {...this.linkState("data:move.1.salida")}
							   min={moment(this.state["data:move.0.regreso"], "HH:mm:ss").add(1, "minute").format("HH:mm:ss")}
							   required/>
					</label>
					<label className="columns small-3">
						<em>Regreso #2</em>
						<input type="time" {...this.linkState("data:move.1.regreso")}
							   min={moment(this.state["data:move.1.salida"], "HH:mm:ss").add(1, "minute").format("HH:mm:ss")}
							   required/>
					</label>
					<label className="columns small-3">
						<em>Modelo</em>
						<select {...this.linkState("modelo")} required>
							<option disabled value=""> --- Selectiona ---</option>
							{models}
						</select>
					</label>
					<label className="columns small-3">
						<em>Autobus</em>
						<select disabled={!this.state.modelo} {...this.linkState("autobus")} required>
							<option disabled value=""> --- Selectiona ---</option>
							{buses}
						</select>
					</label>
					<label className="columns small-3">
						<em>Folio</em>
						<input type="number" {...this.linkState("folio")}/>
					</label>
					<label className="columns small-3">
						<em>Contratante</em>
						<select {...this.linkState("contratante")}>
							<option disabled value=""> --- Selectiona ---</option>
							{contratantes}
						</select>
					</label>
					<div className="columns small-12">
						<div className="row">
							{[0, 1, 2, 3, 4, 5, 6].map(n=>(
								<label className="columns check-day" key={n}>
									<em style={{textTransform: "capitalize"}}>{moment(this.state.semana).weekday(n).format("ddd")}</em>
									<input type="checkbox" checked={this.state.selection[n]} value={this.state.selection[n]}
										   onChange={this.handleSelectionUpdate.bind(this,n)}
									/>
									<em>{moment(this.state.semana).weekday(n).format("DD/MM")}</em>
								</label>
							))}
						</div>
					</div>
					<label className="columns small-6">
						<em>Destino</em>
						<input type="text" {...this.linkState("destino")} required/>
					</label>
					<label className="columns small-6">
						<em> </em>
						<button type="submit" className="button success expanded"
								disabled={this.state.fetching}
						>
							Guardar
						</button>
					</label>
				</div>
			</form>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/form_service_route.js
 **/